import axiosInstance from "./api";
import DebounceSelect from "./DebounceSelect";

export default function SelectUser(props) {
    return (
        <DebounceSelect
            fetchOptions={(query) =>
                axiosInstance
                    .get("user", {
                        params: { query, page: 0, pageSize: 99999 },
                    })
                    .then(({ data }) =>
                        data.data.map((x) => ({
                            value: x.id,
                            label: x.firstName + " " + x.lastName,
                        })),
                    )
            }
            {...props}
        />
    );
}
